import React from "react";
import getSize from "../../../utils/getSize";
import NHTable from '../../common/NHTable';
import css from './index.css';
import {hasAuth} from "../../../utils/NHCore";
import { Button } from 'antd';

/**
 * 报到情况查询
 * @author sujunming
 * @date 2018-07-03 15:45:03
 * Version: 1.0
 */
class BdqkcxTab extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            initParams: {},
            selectKey: '',
            columns: [],
        }
    }

    handleOtpBtnClick = () => {
        this.refs.nhTable.exportExcel('报到情况填写');
    }

    render() {
        const columnConst = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '50px',
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '120px',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '90px',
                search: 'input',
                searchType:"input"
            }, {
                title: '性别',
                width: '70px',
                dataIndex: 'XB',
                searchType:"select"
            }, {
                title: '身份证号',
                dataIndex: 'SFZJH',
                width: '160px',
                searchType:"input"
            }, {
                title: '院系',
                width: '200px',
                dataIndex: 'BMMC',
                searchType:"select"
            }, {
                title: '专业',
                width: '200px',
                dataIndex: 'ZYMC',
                searchType:"select",
                parentField:"BMMC"
            }, {
                title: '班级',
                width: '200px',
                dataIndex: 'BJMC',
                searchType:"select",
                parentField:"ZYMC"
            }, {
                title: '出发地',
                width: '150px',
                dataIndex: 'CFD',
                searchType:"select"
            },{
                title: '是否按时报到',
                width: '150px',
                dataIndex: 'SFASBD',
                searchType:"select"
            }, {
                title: '不按时报到原因',
                width: '200px',
                dataIndex: 'BASBDYY',
                searchType:"input"
            }, {
                title: '交通工具',
                width: '100px',
                dataIndex: 'JTGJMC',
                searchType:"select"
            }, {
                title: '到达站',
                width: '100px',
                dataIndex: 'DDZ',
                searchType:"input"
            }, {
                title: '班次',
                width: '100px',
                dataIndex: 'BC',
                searchType:"input"
            },{
                title: '到校时间',
                width: '145px',
                dataIndex: 'DXSJ',
                commonSearch:false,
                searchType:"datetime"
            }, {
                title: '陪同人数',
                width: '100px',
                dataIndex: 'PTRS',
                searchType:"input"
            }
        ];
        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 230 }}>
                <div style={{ width: '100%', height: '100%', }}>
                    <NHTable ref='nhTable'
                        rowKey={record => record.PKID}
                        sign={"zhxg_yxxt_tjcx_bdqkcx_queryPage"}
                        columns={columnConst}
                        rangeFilter={true}
                    >
                        {hasAuth("zhxg_yxgl_tjcx_bdqkcx:export") ? <Button type="primary" ghost onClick={this.handleOtpBtnClick} style={{ marginLeft: 10 }}>导出</Button> : undefined}
                    </NHTable>

                </div>
            </div>
        )
    }
}
export default BdqkcxTab;



// WEBPACK FOOTER //
// ./components/tjcx/bdqkcx/bdqkcxTab_Jx.js